import { Quality, createQuality } from '../models/quality.model';

export const QUALITIES = {
  Normal: createQuality(1, 'Normal', 0, 689),
  Good: createQuality(2, 'Good', 20, 250),
  Outstanding: createQuality(3, 'Outstanding', 40, 50),
  Excellent: createQuality(4, 'Excellent', 60, 10),
  Masterpiece: createQuality(5, 'Masterpiece', 100, 1),
};

export function getAllQualities(): Quality[] {
  return Object.values(QUALITIES);
}

export function getQualityByIndex(index: number): Quality {
  const quality = Object.values(QUALITIES).find((quality) => quality.index === index);
  if (!quality) {
    throw new Error(`Quality with index ${index} not found.`);
  }
  return quality;
}

export function getQualityByName(name: string): Quality {
  const quality = Object.values(QUALITIES).find((quality) => quality.name === name);
  if (!quality) {
    throw new Error(`Quality with name ${name} not found.`);
  }
  return quality;
}

export function getQuality(nameOrIndex: string | number): Quality {
  if (typeof nameOrIndex === 'string') {
    return getQualityByName(nameOrIndex);
  }
  return getQualityByIndex(nameOrIndex);
}
